import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const programi = [
  { id: 'vasco', naziv: 'Vasco', opis: 'GK Vasco računovodski program', logo: '🏢', available: true },
  { id: 'pantheon', naziv: 'Pantheon', opis: 'Datalab Pantheon ERP', logo: '⚡', available: false },
  { id: 'minimax', naziv: 'Minimax', opis: 'Minimax računovodstvo v oblaku', logo: '☁️', available: false },
  { id: 'nav', naziv: 'MS Dynamics NAV', opis: 'Microsoft Dynamics NAV/BC', logo: '🔷', available: false },
  { id: 'odoo', naziv: 'Odoo', opis: 'Odoo ERP sistem', logo: '🟣', available: false },
  { id: 'desito', naziv: 'Desito', opis: 'Desito poslovni informacijski sistem', logo: '📊', available: false },
  { id: 'sap', naziv: 'SAP', opis: 'SAP Business One', logo: '🔵', available: false },
  { id: 'eracuni', naziv: 'e-Računi', opis: 'e-Računi spletna rešitev', logo: '📄', available: false },
  { id: 'oppis', naziv: 'OpPIS', opis: 'OpPIS poslovni informacijski sistem', logo: '📋', available: false },
];

export function ProgramiPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">AI Agenti</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">Izberite računovodski program</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {programi.map(p => (
          <button key={p.id}
            onClick={() => p.available && navigate(`/agenti/${p.id}`)}
            disabled={!p.available}
            className={`text-left p-5 rounded-2xl border transition flex items-center justify-between group ${
              p.available
                ? 'bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800 hover:border-blue-400 hover:shadow-md cursor-pointer'
                : 'bg-gray-50 dark:bg-gray-900/50 border-gray-100 dark:border-gray-800 opacity-50 cursor-not-allowed'
            }`}>
            <div className="flex items-center gap-4">
              <span className="text-3xl">{p.logo}</span>
              <div>
                <p className="font-semibold text-gray-900 dark:text-white">{p.naziv}</p>
                <p className="text-xs text-gray-500 mt-0.5">{p.opis}</p>
                {!p.available && <span className="text-xs text-gray-400">Kmalu na voljo</span>}
                {p.available && <span className="text-xs text-green-600 dark:text-green-400">Na voljo</span>}
              </div>
            </div>
            {p.available && <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-blue-400 transition" />}
          </button>
        ))}
      </div>
    </div>
  );
}
